import { IThreeVariantXP } from '@faire/web-api--source/indigofair/settings/IThreeVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Test2: Experiment to update product tiles to have price-first for visitors
 * https://www.notion.so/faire/Low-lift-testing-Batch-8
 */
export const LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317 =
  'LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317' as SettingConst<
    'LOGGED_OUT_PROMINENT_PRICE_PRODUCT_TILES_250317',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER' | 'VISITOR_WEB'
  >;
